export default __webpack_public_path__ + "static/media/EM0230.34I-22673_-16740_0.84f11041.jpg";